import { sdkContextStatus } from "src/context/SDKContext"
import { useQuery, useQueryClient } from "react-query"
import axios from "src/shared/axios"

const QUERY_KEY = "recent-chats"

export type RecentChatModel = {
  timestamp: Date
  toAvatarId: string
  generation: number
  roomHash: string
  message: string
  author: string
}

export function useRecentChats() {
  const queryClient = useQueryClient()
  const { data } = useQuery({
    queryKey: [QUERY_KEY],
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const meetingClient = await sdkContextStatus
      const url = new URL(meetingClient?.envConfig.RECENT_CHATS)
      url.searchParams.append("host", meetingClient?.envConfig.DOMAIN_HOSTNAME)
      const response = await axios.get(url.toString(), {
        withCredentials: true
      })
      return response.data
    }
  })

  const chats: RecentChatModel[] = data?.chats?.sort(
    (a, b) => a.timestamp - b.timestamp
  )

  const invalidateRecentChats = () => {
    queryClient.invalidateQueries(QUERY_KEY)
  }

  return { chats, invalidateRecentChats }
}
